const isTraceEnabled = window.localStorage.getItem('trace') === 'enabled';

export const trace =
    // biome-ignore lint/suspicious/noExplicitAny: out of convenience
    import.meta.env.DEV || isTraceEnabled ? (...args: any) => console.log('[TRACE]', ...args) : () => {};
